var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mt-5",attrs:{"fluid":"lg"}},[_c('b-row',[_c('b-col',{attrs:{"lg":"6","offset-lg":"3"}},[_c('h2',[_vm._v("Login")]),_c('b-card',[_c('b-card-text',[_vm._v("You have been logged out.")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }